module.exports = __webpack_public_path__ + "static/media/tiktok.f87c8b03.svg";